import { useRef, useState } from 'react';
import { acknowledgeTasbeehGoals, reachedTasbeehGoals } from '../services/tasbeehGoals';
import { vibrateTasbeeh } from '../services/tasbeehHaptics';

export default function useTasbeehGoalGate(account, dhikr, view, onChoose, vibration, duration) {
  const [forced,setForced]=useState(null), [,refresh]=useState(0);
  const day=new Date().toISOString().slice(0,10), current=useRef([]);
  const same=forced?.account===account ? forced.goals.filter(goal=>goal.day===day && goal.dhikr===dhikr &&
    (goal.scope==='dhikr' ? view.dhikrGoal===goal.goal && (view.dhikrGoalUpdatedAt||0)===goal.version
      : view.goal===goal.goal && (view.goalUpdatedAt||0)===goal.version)) : [];
  current.current=same?.length?same:reachedTasbeehGoals(account,dhikr,view,day);
  const notify=goals=>{current.current=goals;setForced(goals.length?{account,goals}:null);};
  return {
    goals:current.current, blocked:()=>current.current.length>0,
    counted:next=>{const goals=reachedTasbeehGoals(account,dhikr,next);notify(goals);if(goals.length)vibrateTasbeeh(vibration,duration);return goals.length>0;},
    rejected:error=>{if(error.code!=='TASBEEH_GOAL_REACHED')return false;notify(error.goals);return true;},
    continue:()=>{acknowledgeTasbeehGoals(account,current.current);current.current=[];setForced(null);refresh(value=>value+1);},
    choose:()=>{acknowledgeTasbeehGoals(account,current.current,false);setForced(null);onChoose();},
  };
}
